import { render, staticRenderFns } from "./orderLists.vue?vue&type=template&id=132d0b4c&scoped=true&"
import script from "./orderLists.vue?vue&type=script&lang=js&"
export * from "./orderLists.vue?vue&type=script&lang=js&"
import style0 from "./orderLists.vue?vue&type=style&index=0&id=132d0b4c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "132d0b4c",
  null
  
)

export default component.exports